// src/components/probe/ProbeRequestList.tsx
import React from 'react';

interface ProbeListProps {
  probeName: string;
  probeIds: string[];
  onSelect: (requestId: string) => void;
}

const ProbeList: React.FC<ProbeListProps> = ({ probeName, probeIds,  onSelect }) => {
  if (probeIds.length === 0) return null;

  return (
    <div className="p-4">
      <h3 className="text-lg font-semibold mb-3 text-text-light">List: {probeName} </h3>
      <ul className="space-y-2">
        {probeIds.map((id, index) => (
          <li key={index}>
            <button onClick={() => onSelect(id)}
              className="bg-transparent border-none text-link-color hover:underline text-sm break-all text-left w-full"
            >
              {id}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProbeList;